import PropTypes from "prop-types";
import { Button } from "./Buttons";
import { useState } from "react";

function LoadingButton({ children, onClick, ...otherProps }) {
  const [l, setL] = useState(false);

  async function handleClickAndLoadingState(e) {
    setL(true);
    await onClick(e);
    setL(false);
  }

  return (
    <Button
      className={`inline-flex items-center transition duration-150 ease-in-out ${l ? "cursor-not-allowed" : "cursor-pointer"} ${otherProps.className ?? ""}`}
      {...otherProps}
      onClick={handleClickAndLoadingState}
      disabled={otherProps.disabled || l}
    >
      {l ? (
        <svg
          className="mr-3 -ml-1 size-5 animate-spin text-white"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="4"
          ></circle>
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          ></path>
        </svg>
      ) : (
        children
      )}
    </Button>
  );
}

LoadingButton.propTypes = {
  children: PropTypes.node,
};

const LoadingButtonPrimary = (props) => (
  <LoadingButton color="green" {...props} />
);
const LoadingButtonSecondary = (props) => (
  <LoadingButton color="blue" {...props} />
);
const LoadingButtonError = (props) => <LoadingButton color="red" {...props} />;

export {
  LoadingButton,
  LoadingButtonPrimary,
  LoadingButtonSecondary,
  LoadingButtonError,
};
